import PlayCircleIcon from '@mui/icons-material/PlayCircle';
import ECircualrProgress from './ECircualrProgress';
import { InsertDriveFile } from '@mui/icons-material';
import { Box, Typography } from '@mui/material';

interface IProps {
	type?: 'image' | 'video' | 'media' | 'file';
	file?: File | string;
	loaded?: number;
	url?: string;
}

export default function PreviewUpload({ type = 'image', file, loaded, url }: IProps) {
	if (!file) {
		return (
			<div className="relative h-14 w-14">
				<img className="h-14 w-14 rounded object-cover" src={file} />
			</div>
		);
	}

	switch (type) {
		case 'image':
			if (typeof file === 'string') {
				return (
					<div className="relative h-14 w-14">
						<img className="h-14 w-14 rounded object-cover" src={file} />
					</div>
				);
			} else {
				return (
					<div className="relative h-14 w-14">
						{loaded! < 100 && <ECircualrProgress value={loaded!} size={25} />}
						<img className="h-14 w-14 rounded object-cover" src={URL.createObjectURL(file!)} />
					</div>
				);
			}
		case 'video':
			if (typeof file === 'string') {
				return (
					<div className="relative h-14 w-14">
						<video className="h-14 w-14 rounded object-cover" src={file} />
					</div>
				);
			} else {
				return (
					<div className="relative h-14 w-14">
						{loaded! < 100 ? <ECircualrProgress value={loaded!} size={25} /> : <PlayCircleIcon className="center text-action-active" />}
						<video className="h-14 w-14 rounded object-cover" src={URL.createObjectURL(file!)} />
					</div>
				);
			}
		case 'media':
		case 'file':
			if (typeof file === 'string') {
				return (
					<div className="relative h-14 w-14">
						{url?.split('.').pop() === 'mp4' ? (
							<video className="h-14 w-14 rounded object-cover" src={file} />
						) : type === 'media' || ['jpg', 'png', 'jpeg', 'webp', 'jfif'].indexOf(file?.split('.')?.pop() ?? '') > -1 ? (
							<img className="h-14 w-14 rounded object-cover" src={file} />
						) : (
							<Box className={'relative'}>
								<InsertDriveFile className="h-14 w-14 rounded object-cover text-grey-300" />
								<Typography className={'absolute bottom-1 left-3 right-3 truncate'}>{file?.split('.').pop()}</Typography>
							</Box>
						)}
					</div>
				);
			} else {
				return (
					<div className="relative h-14 w-14">
						{loaded! < 100 && <ECircualrProgress value={loaded!} size={25} />}
						{file?.type?.split('/')?.[0] === 'video' ? (
							<video className="h-14 w-14 rounded object-cover" src={URL.createObjectURL(file!)} />
						) : type === 'media' || file?.type?.split('/')?.[0] === 'image' ? (
							<img className="h-14 w-14 rounded object-cover" src={URL.createObjectURL(file!)} />
						) : (
							<Box className={'relative'}>
								<InsertDriveFile className="h-14 w-14 rounded object-cover text-grey-300" />
								<Typography className={'absolute bottom-1 left-3 right-3 truncate'}>{file?.type?.split('/')?.[1]}</Typography>
							</Box>
						)}
					</div>
				);
			}
	}
}
